// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3Ko7C","errors":"Errors_errors__2Ajr-"};